import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const SpeakerCard = ({ speaker }) => {
  const navigate = useNavigate();
  const cardRef = useRef(null);

  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: cardRef.current,
        start: "top 80%",
        toggleActions: "play none none none",
      },
    });

    tl.fromTo(
      cardRef.current,
      { opacity: 0, scale: 0.8 },
      {
        opacity: 1,
        scale: 1,
        duration: 0.8,
        ease: "power2.out",
      }
    );
  }, []);

  return (
    <div
      ref={cardRef}
      onClick={() => navigate(`/speakers/${speaker.id}`)}
      className="cursor-pointer flex justify-start flex-col max-w-[14.8125rem]"
    >
      <div className="speaker__thumb relative w-[14.8125rem] h-[16.0625rem]">
        <div className="relative w-full h-full">
          <img
            className="rounded-[1.125rem] absolute top-0 left-0 w-full h-full mix-blend-luminosity object-cover"
            src={speaker.image}
            alt={speaker.name}
          />
        </div>
      </div>
      <h3 className="leading-[1.5625rem] text-[1.375rem] text-start mt-[1.4375rem] font-bold text-white inline">
        {speaker.name}
      </h3>
      <h4 className="mt-[0.3125rem] text-start text-[1.125rem] text-white inline font-normal">
        {speaker.title}
      </h4>
    </div>
  );
};

export default SpeakerCard;
